export default __webpack_public_path__ + "static/media/file9.01886ba5.jpg";